import { CommonTrainInfoFormProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoForm";
import { CommonSubTypeProps } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/TrainInfoFormModal";
import { SelectStopsFields } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/SelectStopsFields";
import { TrainContext } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/subTypeInputs/utils/formContextWrappers";
import { FC } from "react";
import { useTranslation } from "react-i18next";

export const TrainStoppingExtraAtStation: FC<
  CommonTrainInfoFormProps & CommonSubTypeProps & TrainContext
> = (props) => {
  const { t } = useTranslation();
  return (
    <SelectStopsFields
      {...props}
      stopsField="extraStops"
      justPassingThough
      label={t("Ekstra stasjon")}
    />
  );
};
